import { useState } from "react";
import { FilterComponentState, FormFilter_VM } from "./FormFilter.component";
import { FormFilter } from "../../../core/models/FormFilter";
import { useAuthenticationContext } from "../../../contexts/UserContext";
import {
    getFormErrorTypes,
    StatusCodeType
} from "../../../core/functions/GetFormErrorTypes";
import { FormErrorType } from "../../../core/entities/FormErrorType";
import { isValidFilterForm } from "../../../core/functions/FormFilterValidation";
import { getStatusCodes } from "../../../core/functions/GetStatusCodes";
import { useResourceContext } from "../../../contexts/ResourceContext";

const filterOpenKey = "filterOpen";

export function useFormFilterViewModel(
    argFilter: FormFilter,
    onFilterReset: () => void,
    handleFilterForm: (filter: FormFilter) => void
): FormFilter_VM {
    const { isSuperAdmin } = useAuthenticationContext();
    const { municipalities } = useResourceContext();
    const [filter, setFilter] = useState<FormFilter>(argFilter);
    const [errorTypes] = useState<FormErrorType[]>(getFormErrorTypes());
    const [statusTypes] = useState<StatusCodeType[]>(getStatusCodes());
    const [open, setOpen] = useState<boolean>(getInitialOpenState());

    const componentState = isValidFilterForm(filter)
        ? FilterComponentState.valid
        : FilterComponentState.invalid;

    function setOpenState(open: boolean) {
        setOpen(open);
        localStorage.setItem(filterOpenKey, String(open));
    }

    function getInitialOpenState(): boolean {
        const storageItem = localStorage.getItem(filterOpenKey);
        if (storageItem == null) {
            return isSuperAdmin;
        }
        return localStorage.getItem(filterOpenKey) === "true";
    }

    function handleFilterChange(field: string, value: string) {
        setFilter((prevValue) => ({ ...prevValue, [field]: value }));
    }

    function onFormChange() {
        if (componentState === FilterComponentState.valid) {
            handleFilterForm(filter);
        }
    }

    function handleFilterReset() {
        setFilter({
            ssn: "",
            name: "",
            errorTypes: [],
            statusTypes: [],
            onlyFormsWithError: false,
            documentId: "",
            municipalities: []
        });
        onFilterReset();
    }

    return {
        handleFilterReset,
        errorTypes,
        handleFilterChange,
        filterFormModel: filter,
        componentState: componentState,
        onFormChange: onFormChange,
        isOpen: open,
        setOpenState,
        statusCodes: statusTypes,
        extendedFilters: isSuperAdmin,
        municipalities
    };
}
